<template>
  <div :class="{ 'rightone': index==0 }" class="goodslist swiper-slide" :style="{width:itemwidth,'margin-right':itemright,'margin-top':itemtop}">
    <template v-if="goodsmore==''" >
      <div class="goodsimg" @click="gotogoodsinfo(goods.id)">
          <img :src="goods.pic">
      </div>
      <div class="goodsinfo" >
          <p class="goodsname" :title="goods.name" @click="gotogoodsinfo(goods.id)">
               {{goods.name}}
          </p>
          <ul @click="gotogoodsinfo(goods.id)">
              <li v-for="(param,paramindex) in goods.parameter" :key="paramindex">
                  <p class="xinghao">{{paramindex}}：{{param}}</p>
              </li>              
          </ul>
          <div class="pricesc">
              <span @click="gotogoodsinfo(goods.id)">参考价：￥{{goods.price}}</span> 
          </div>
          <div class="compare-box">
            <i  @click="editgoods(goods.id)" :class="goods.store==1?iconon:iconoff"></i>
            <el-checkbox
              :value="isChecked"
              @change="handleCompareChange"
            >
                对比
            </el-checkbox>
          </div>
      </div>
    </template>
    <template v-else>        
        <img class="goodslistimg" :src="goodsmore" @click="goto()">          
    </template>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {

    props: {
        index:{
            type: Number,
            default: 0
        },
        goods:{
            type: Object,
            default:() => ({})
        },
        iconoff:{
            type: String,
            default: ""
        },
        iconon:{
            type: String,
            default: ""
        },
        goodsmore:{
            type: String,
            default: ""
        },
        index1:{
            type:Number,
            default: 0
        },
        index2:{
            type:Number,
            default: 0
        },
        urlname:{
            type:String,
            default:""
        },
        params:{
            type:Object,
            default:() => ({})
        },
        itemwidth:{
            type:String,
            default: "213px"
        },
        itemright:{
            type:String,
            default: "29px"
        },
        itemtop:{
            type:String,
            default: "33px"
        }

    },
    computed: {
        ...mapGetters(["compareList"]),
        isChecked() {
            if (!this.goods || !this.goods.id) return false;
            // 用 String 比较，避免不同接口返回的 id 类型不一致（数字/字符串）导致已添加判断失效
            return this.compareList.some(item => String(item.id) === String(this.goods.id));
        }
    },
    methods:{

        handleCompareChange(){
            // console.log(this.isChecked);
            // console.log(this.goods.id,'goods.id');
            // console.log(this.compareList,'compareList');
            if (!this.goods || !this.goods.id) return;
            // if (this.isChecked) {
            //     this.$store.commit("removeCompareGoods", this.goods.id);
            // }
            // 注：上面"已勾选先移除"已注释——addCompareGoods 内部本身有去重，重复添加不会生效；
            // 且先移除会改变列表顺序、影响下面的类型校验
            if (!this.isChecked) {
                // 当前未勾选 → 执行添加前校验：最多 4 件（取消勾选时不受此限制）
                if (this.compareList.length >= 4) {
                    this.$message.warning("最多添加4个产品进行对比！");
                    this.$root.$emit('show-compare-panel');
                    return;
                }
                // 类型不一致，只能添加同类型方案进行对比！
                if (this.goods.idx_cid1 && this.compareList.length > 0 &&
                    this.compareList.some(item => item.idx_cid1 && item.idx_cid1 != this.goods.idx_cid1)) {
                    this.$message.warning("类型不一致，只能添加同类型产品进行对比！");
                    // 类型不一致时展开对比侧边栏，方便用户查看已添加的产品
                    this.$root.$emit('show-compare-panel');
                    return;
                }
                const goods = {
                    ...this.goods,
                    parameterStr: Object.entries(this.goods.parameter || {})
                        .map(([k, v]) =>  v) //k + '：' + v
                        .join(' ')
                };
                this.$store.commit("addCompareGoods", goods);
                // 当前页面主动勾选添加成功后，展开对比侧边栏
                this.$root.$emit('show-compare-panel');
            } else {
                this.$store.commit("removeCompareGoods", this.goods.id);
                this.$root.$emit('show-compare-panel');
            }
        },
        editgoods(goodsid){
            this.$emit('editgoods',goodsid,this.index,this.index1,this.index2);
        },
        goto(){
            if(this.urlname=="goodslist"){
                var pid = this.params.pid==0?this.params.id:this.params.pid;
                var classid = this.params.pid==0?0:this.params.id;
                var classname = this.params.pid==0?this.params.name:this.params.pname;
                this.$router.push({name:this.urlname,params:{pid:pid,classid:classid,classname:classname}})
            }else{
                this.$router.push({name:this.urlname,params:{id:1}})
            }
            
        },
        gotogoodsinfo(goodsid){
            const routeData = this.$router.resolve({name:"goodsinfo",params:{goodsid:goodsid}})
            window.open(routeData.href, '_blank')
                }   
    }
}
</script>

<style scoped>

.compare-box >>> .el-checkbox__input.is-checked .el-checkbox__inner:after{
    /* transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg); */
    border: 1px solid #FBB113;
    border-left: 0;
    border-top: 0;
    background-color: transparent;
    height: 8px;
    width: 4px;
    left: 4px;
    top: 0px;
    transition: none !important;
  }
  .compare-box >>> .el-checkbox__inner{
    border:1px solid #999999;
    height:14px;
    width: 14px;
    transition: none !important;
  }

  .attrlist >>> .el-checkbox__input.is-focus .el-checkbox__inner{
    border:1px solid #737373;
  } 
  .compare-box >>> .el-checkbox .el-checkbox__label{  
    color:#737373;
    padding-left: 5px;
    /* color:#FBB113; */
  }
  .compare-box >>> .el-checkbox__input.is-checked .el-checkbox__inner, .compare-box >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#FBB113;
    transition: none !important;
  }
  .compare-box >>> .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #FFFFFF;
    border:1px solid #FBB113;
    transition: none !important;
  }
  .compare-box >>> .el-checkbox__input.is-checked+.el-checkbox__label{  
    color:#FBB113;
  }
    .goodslist{
        width: 213px;
        overflow: hidden;
        float: left;
        margin-right: 29px;
        margin-top: 33px;
        border-radius: 5px;
        height: 362px;
        cursor:pointer;
        background-color: #fff;
    }
    .goodslist:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .rightone{
        margin-right:0;
    }
    /* .rightone:hover{
        box-shadow: none;
    } */
    .goodsimg{
        width: 213px;
        overflow: hidden;

    }
    .goodsimg img{
        margin-top: 12px;
        margin-left: 16px;
        width: 181px;
        height: 180px;

    }
    .goodsinfo{
        width: 193px;
        overflow: hidden;
        padding: 10px;
        text-align: left;
    }
    .goodsinfo .goodsname{
        font-size: 15px;
        height:20px;
        color: #303030;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .pricesc{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .goodsinfo li{
        font-size: 12px;
        margin-top:2px;
        color: #555555;
        line-height: 1.6;
    }
    .goodsinfo .xinghao{
        overflow:hidden;

        white-space: nowrap;

        text-overflow: ellipsis;

        -o-text-overflow:ellipsis;
    }
    .goodsinfo span{
        font-size: 14px;
        color: #FF0000;
    }
    .goodsinfo i{
        color: #FBB113;
        float: right;
    }
    .goodsinfo ul{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .compare-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;
        font-size: 13px;
        user-select: none;
    }
    .compare-box .el-checkbox{
        margin-right: 6px;
    }
    .icon-shoucang1:before{
        font-size: 23px;
    }
    .el-icon-star-off:before{
        font-size: 25px;
    }
    .goodslistimg{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/UserCollectionInfoItem.vue